module.exports = __webpack_public_path__ + "img/visibility.4e060f7c.svg";